// src/components/Testimonials.js
import React, { useState } from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const [activeCase, setActiveCase] = useState('dr-meoli');

  const stats = [
    { value: '98.17%', label: 'Accuracy Rate & Clean Claims Submission' },
    // { value: '95%', label: 'Client Satisfaction & 4.8 Stars Google Rating' },
    { value: '97%', label: 'Claims Finalizing in First 25 Days' },
    { value: '98%+', label: 'First Time Passing Rate' },
    { value: '99%', label: 'Same Day Billing' },
    { value: '15-30%', label: 'Revenue Increase' }
  ];

  return (
    <main className="testimonials-page">
      {/* Hero Section */}
      <section className="testimonials-hero">
        <div className="container">
          <div className="testimonials-hero-content">
            <h1 className="testimonials-hero-title">
              Stop Chasing Denials. <span className="highlight">Start Growing Your Practice!</span>
            </h1>
            <p className="testimonials-hero-description">
              Are you tired of filing denials, chasing down revenue, managing billing staff and correcting endless billing errors? 
              You're not alone — and you don't have to keep doing it.
            </p>
            <p className="testimonials-hero-description">
              Imagine a solution that eliminates these headaches, increases your revenue, and gives you back your time. 
              Let us handle the complexities of your medical billing, so you can focus on what truly matters: patient care and practice growth.
            </p>
            <button className="hero-schedule-btn">SCHEDULE A DEMO →</button>
          </div>
        </div>
      </section>

      {/* We Offer Section */}
      <section className="we-offer-section">
        <div className="container">
          <div className="offer-header">
            <h2 className="offer-title">We Offer</h2>
            <p className="offer-subtitle">
              Let's simplify your revenue cycle. Schedule a free consultation today and discover how effortless billing can be.
            </p>
          </div>
          <div className="stats-grid-testimonials">
            {stats.map((stat, index) => (
              <div className="stat-card-testimonial" key={index}>
                <div className="stat-value-testimonial">{stat.value}</div>
                <div className="stat-label-testimonial">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Client Says Section */}
      <section className="client-says-section">
        <div className="container">
          <div className="client-says-header">
            <h2 className="client-says-title">Here's what our clients say about us:</h2>
            <p className="client-says-description">
              Our clients consistently praise the accuracy, reliability, and peace of mind we bring to their billing operations. 
              From significantly reducing denials to streamlining their entire revenue cycle, they've experienced real results — 
              and real relief. Their success stories speak for themselves.
            </p>
          </div>
          
          {/* Testimonial Cards */}
          <div className="testimonial-cards">
            <div className="testimonial-card">
              <div className="testimonial-rating">★★★★★</div>
              <p className="testimonial-text">
                "Providers Care Billing transformed our revenue cycle. Our denial rate dropped from 15% to under 3% in just 3 months. 
                The team is responsive, professional, and truly cares about our success."
              </p>
              <div className="testimonial-author">
                <strong>Dr. Sarah Johnson</strong>
                <span>Cardiology Specialist, Texas</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-rating">★★★★★</div>
              <p className="testimonial-text">
                "The best decision we ever made was outsourcing our billing to Providers Care. Our collections increased by 28% 
                and we finally have peace of mind knowing our claims are handled properly."
              </p>
              <div className="testimonial-author">
                <strong>Michael Rodriguez</strong>
                <span>Practice Manager, Florida</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-rating">★★★★★</div>
              <p className="testimonial-text">
                "Their transparency and reporting are outstanding. We always know exactly where our revenue stands. Highly recommended 
                for any practice looking to improve their financial health."
              </p>
              <div className="testimonial-author">
                <strong>Dr. Emily Chen</strong>
                <span>Pediatrician, California</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Case Studies Section */}
      <section className="case-studies-section">
        <div className="container">
          <h2 className="case-studies-title">Case Studies: See Our Impact</h2>
          <p className="case-studies-subtitle">
            Explore the success stories behind our clients' growth. Read real stories from real healthcare providers. 
            Discover how Providers Care Billing LLC drives measurable results for practices.
          </p>

          {/* Case Study Tabs */}
          <div className="case-tabs">
            <button 
              className={`case-tab ${activeCase === 'dr-meoli' ? 'active' : ''}`}
              onClick={() => setActiveCase('dr-meoli')}
            >
              Dr. Meoli's Practice
            </button>
            <button 
              className={`case-tab ${activeCase === 'laura' ? 'active' : ''}`}
              onClick={() => setActiveCase('laura')}
            >
              Laura W's Practice
            </button>
            <button 
              className={`case-tab ${activeCase === 'julia' ? 'active' : ''}`}
              onClick={() => setActiveCase('julia')}
            >
              Julia H's Practice
            </button>
          </div>

          {/* Case Study 1 - Dr. Meoli */}
          {activeCase === 'dr-meoli' && (
            <div className="case-study-content">
              <div className="case-study-header">
                <span className="case-badge">Billing Services Solution</span>
                <h3 className="case-study-title">How Dr. Meoli streamlined His Practice's billing with Providers Care Billing LLC?</h3>
              </div>
              <div className="case-study-grid">
                <div className="case-section">
                  <h4>BACKGROUND:</h4>
                  <p>Dr. Meoli is the owner of a private practice based in MA. He has been in business for many years. His practice name is Virtuous Behavioral Health. This is a group practice with many providers of different specialties.</p>
                </div>
                <div className="case-section">
                  <h4>DR. MEOLI'S CHALLENGES:</h4>
                  <p>His billing team was not submitting claims on a regular basis and claims were being submitted without checking the billing guidelines so denial rate was more than 10% and first time passing rate was less than 80%. His billing team was not taking action on denials in a timely manner so more than 10% claims were getting denied for timely filing. His AR was very high.</p>
                </div>
                <div className="case-section">
                  <h4>PROVIDERS CARE BILLING LLC'S ACTION PLAN:</h4>
                  <ul>
                    <li>Timely submission of claims decreased the collection time.</li>
                    <li>Proactive approach helped his practice reduce billing errors and denial rate.</li>
                    <li>Timely action on denied claims helped his practice reduce the AR significantly.</li>
                  </ul>
                </div>
                <div className="case-section results-section">
                  <h4>RESULTS:</h4>
                  <ul>
                    <li>Timely submission of claims decreased the overall collection time.</li>
                    <li>A proactive approach reduced billing errors and denial rates.</li>
                    <li>Prompt action on denied claims significantly lowered the AR.</li>
                  </ul>
                  <div className="results-stats">
                    <div className="result-stat">
                      <span className="result-value">99%</span>
                      <span className="result-label">Collection Rate</span>
                    </div>
                    <div className="result-stat">
                      <span className="result-value">99%</span>
                      <span className="result-label">First-Time Passing Rate</span>
                    </div>
                    <div className="result-stat">
                      <span className="result-value">92%</span>
                      <span className="result-label">Increase in Total Collection</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="case-study-footer">
                <button className="learn-more-btn">Learn More</button>
                <button className="contact-us-btn">Contact Us</button>
              </div>
            </div>
          )}

          {/* Case Study 2 - Laura W */}
          {activeCase === 'laura' && (
            <div className="case-study-content">
              <div className="case-study-header">
                <span className="case-badge">E.H.R Solution & Automation</span>
                <h3 className="case-study-title">How Laura W streamlined Her Practice's billing with Providers Care Billing LLC?</h3>
              </div>
              <div className="case-study-grid">
                <div className="case-section">
                  <h4>BACKGROUND:</h4>
                  <p>Laura is a MA-based provider who runs her private practice for a long time. She has been using an old billing system and many manual processes to handle billing, AR, and denials.</p>
                </div>
                <div className="case-section">
                  <h4>LAURA'S CHALLENGES:</h4>
                  <p>Her practice has been using an old billing system with manual claims handling and EOB recording processes. She has been facing issues keeping a good track of claims, denials, payments, and copays. Her system was not efficient so she has been paying additional administrative costs to manage many simple tasks.</p>
                </div>
                <div className="case-section">
                  <h4>PROVIDERS CARE BILLING LLC'S ACTION PLAN:</h4>
                  <p>Providers Care Billing LLC offered Laura an efficient billing system and also contracted her for medical billing. Automated billing and claims routing were set up within the system. The Billing Team also helped the practice set up ERAs and EFTs.</p>
                </div>
                <div className="case-section results-section">
                  <h4>RESULTS:</h4>
                  <ul>
                    <li>The new system captured and submitted all claims quickly, improving overall efficiency.</li>
                    <li>Record-keeping became more organized and streamlined.</li>
                    <li>Providers Care Billing LLC set up ERAs and EFTs, speeding up the entire billing process.</li>
                    <li>Secure charge capture and file transfer protocols reduced administrative costs.</li>
                    <li>Laura and her providers now have more time to focus on patient care.</li>
                  </ul>
                </div>
              </div>
              <div className="case-study-footer">
                <button className="learn-more-btn">OPTIMIZE YOUR PRACTICE TODAY →</button>
              </div>
            </div>
          )}

          {/* Case Study 3 - Julia H */}
          {activeCase === 'julia' && (
            <div className="case-study-content">
              <div className="case-study-header">
                <span className="case-badge">Credentialing Solution</span>
                <h3 className="case-study-title">How Julia H streamlined Her Credentialing with Providers Care Billing LLC?</h3>
              </div>
              <div className="case-study-grid">
                <div className="case-section">
                  <h4>BACKGROUND:</h4>
                  <p>Julia is the owner of a private practice. She runs a group practice. She has a fast-growing practice and hires many providers throughout the year. For all new providers, she needs to get contracts with insurance companies before they can bill claims under those providers.</p>
                </div>
                <div className="case-section">
                  <h4>JULIA'S CHALLENGES:</h4>
                  <p>Julia has tried many billing companies in the past for credentialing of her new providers. She has been facing issues like lack of communication, incomplete applications, and delays. Her previous billing companies failed to get her providers onboard with Medicare, Medicaid, MCOs, and HMO plans. Claims of her practice were getting denied as out-of-network due to credentialing issues.</p>
                </div>
                <div className="case-section">
                  <h4>PROVIDERS CARE BILLING LLC'S SOLUTION:</h4>
                  <p>Providers Care Billing LLC works in all states and with all specialties. Their medical billing and credentialing team is well knowledgeable and experienced with all insurance companies including Medicare, Medicaid, MCO/CCO plans, Advantage Plans, Supplemental Plans, PPOs, HMOs, and IPAs. The credentialing team assigned to Julia included a dedicated credentialing expert who collected details on all submitted applications and also gathered checklists and data from insurance companies. They ensured all applications were responded to and all new applications were submitted with 100% accuracy. The team also did regular follow-up on all submitted applications.</p>
                </div>
                <div className="case-section results-section">
                  <h4>RESULTS:</h4>
                  <ul>
                    <li>All expedited applications were processed successfully.</li>
                    <li>New applications were submitted and approved without delay.</li>
                    <li>Constant follow-ups helped speed up the overall processing time.</li>
                    <li>Many applications received back-dated effective dates, allowing payment for past claims.</li>
                    <li>With these back-dated approvals, her practice collected over $25K in past claim revenue.</li>
                    <li>The entire process also helped ensure current claims were processed in-network.</li>
                  </ul>
                </div>
              </div>
              <div className="case-study-footer">
                <button className="learn-more-btn">TALK TO CREDENTIALING TEAM →</button>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="testimonials-cta">
        <div className="container">
          <div className="cta-content-testimonials">
            <h2>LET'S PUT YOUR BILLING TO WORK.</h2>
            <button className="cta-testimonials-btn">Schedule a Free Consultation →</button>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Testimonials;